import {
	FIELD_LAYOUT_ITEM_TYPE,
	PANEL_LAYOUT_ITEM_TYPE,
} from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types/layout-items.tsx';
import {
	type IssueLayoutRequest,
	type FieldRequest,
	type UpdateIssueLayoutRequestFromSwift,
	FIELD,
	PANEL,
} from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/common/types/save-changes.tsx';
import type { UpdateIssueTypeRequest } from '@atlassian/jira-project-settings-apps-issue-type-page-product-features/src/index.tsx';
import { cleanFieldForRequest } from './field/index.tsx';

const NEW_FIELD_KEY_PREFIX = 'new_field_' as const;
export const transformIssueTypeRequestToIssueLayout = (
	data: UpdateIssueLayoutRequestFromSwift,
): IssueLayoutRequest => ({
	items: data.layoutItems
		.map((layoutItem) => {
			// Category should never be null for layout items but we'll add a check here to make flow happy.
			if (layoutItem.category === null) {
				return null;
			}

			switch (layoutItem.layoutItemType) {
				case FIELD_LAYOUT_ITEM_TYPE: {
					// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
					return {
						type: FIELD,
						sectionType: layoutItem.category,
						key: layoutItem.data.key.includes(NEW_FIELD_KEY_PREFIX) ? null : layoutItem.data.key,
						data: cleanFieldForRequest(layoutItem.data),
					} as FieldRequest;
				}
				case PANEL_LAYOUT_ITEM_TYPE: {
					const panel = layoutItem.data;
					return {
						type: PANEL,
						sectionType: layoutItem.category,
						key: panel.key,
						data: {
							name: panel.name,
							operations: panel.operations,
						},
					};
				}
				default:
					// prettier-ignore
					// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
					(layoutItem as never);
					return null;
			}
		})
		.filter(Boolean),
});

export const transformRequest = (
	data: UpdateIssueLayoutRequestFromSwift,
): UpdateIssueTypeRequest => ({
	owners: data.issueLayoutOwners,
	issueLayout: transformIssueTypeRequestToIssueLayout(data),
});
